import { ENV } from "app/client/env";
import { Application } from "app/client/store";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CancelSubscriptionModal } from "./cancel-subscription";
import "./current-membership.scss";

export const CurrentMembership: React.FC<any> = observer(() => {
  const navigate = useNavigate();
  const [cancelSubscriptionModalOpen, setCancelSubscriptionModalOpen] =
    useState(false);

  return (
    <>
      <div className="Membership__Data">
        <div className="Membership__Data-title">Current Membership</div>
        {/* {Application.domain.processing && <div>Processing...</div>} */}
        <>
          <div className="Membership__Data-membership">
            <div className="Membership__Data-membership-label">
              {Application.ui.account.membershipLabel}
            </div>
            <div>
              {Application.session.subscription && (
                <div className="Membership__Data-status-div">
                  <span className="Membership__Data-status-label">Status:</span>
                  <span
                    className={`Membership__Data-status-${
                      Application.ui.account.cancelAtPeriodEnd
                        ? "cancelled"
                        : "active"
                    }`}
                  >
                    {Application.ui.account.subscriptionStatus}
                  </span>
                </div>
              )}
              {Application.ui.account.cancelAtPeriodEnd && (
                <div className="Membership__Data-status-cancelled cancel-at-text">
                  <span className="">
                    {Application.ui.account.cancelSubscriptionAt}
                  </span>
                </div>
              )}
            </div>
          </div>
          {Application.ui.account.subscriptionPrice > 0 && (
            <div className="Membership__Data-text price">
              <span>{Application.ui.account.formattedSubscriptionPrice}</span>
              <span>{Application.ui.account.subscriptionInterval}</span>
            </div>
          )}
          {!Application.ui.account.cancelAtPeriodEnd && (
            <div className="Membership__Data-link">
              <a onClick={() => navigate(ENV.routes.manageMembership)}>
                {Application.ui.account.currentMembershipLabel}
              </a>
              <br />
            </div>
          )}
          <div className="Membership__Data-cancel">
            {!Application.ui.account.cancelAtPeriodEnd && (
              <span
                className="Membership__Data-text cancel"
                onClick={() => setCancelSubscriptionModalOpen(true)}
              >
                {Application.ui.account.cancelMembershipLabel}
              </span>
            )}
          </div>

          {cancelSubscriptionModalOpen && (
            <CancelSubscriptionModal
              setCancelSubscriptionModalOpen={setCancelSubscriptionModalOpen}
            />
          )}
        </>
      </div>
    </>
  );
});
